var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessfullyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 68.999,
    viewBox: "0 0 69 68.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-82.473 -31.679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.152,33.339c-14.338-4.749-30.156,1.022-38.847,13.1-8.765,12.184-8.021,29.317,1.124,41.036a34.52,34.52,0,0,0,61.7-21.266,34.966,34.966,0,0,0-23.98-32.872Zm-5.463,62.148c-14,2.617-28.256-5.94-33.051-19.2a30.015,30.015,0,0,1,13.457-36c12.615-7.2,28.672-3.635,37.757,7.405a29.61,29.61,0,0,1,6.464,18.518,30.071,30.071,0,0,1-24.626,29.276Zm12.425-37.445-3.224,3.222L132.414,75.734,128.85,79.3a2.715,2.715,0,0,1-.933.615c-2.15,1.017-4.1-1.634-5.473-3.011l-6.984-6.98c-.9-.9-2.116-2.078-1.535-3.506a2.858,2.858,0,0,1,4.892-1l6.411,6.408,1.617,1.617,11.619-11.613,6.468-6.466c1.431-1.431,3.331-3.948,5.572-2.238a2.605,2.605,0,0,1,.313.285,2.489,2.489,0,0,1,.285.313c1.238,1.621.179,3.154-.988,4.321Z",
    transform: "translate(-15.66 0)",
    fill: "#94b757"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfullyIcon);
export default __webpack_public_path__ + "static/media/successfully-icon.c9e49a65244e62001653630a7f2aabd6.svg";
export { ForwardRef as ReactComponent };